(() => {
  const normalizePreviewFont = (value) => {
    const font = String(value || '').trim();
    if (!font) return '';
    const comparable = font.replace(/["']/g, '').replace(/\s+/g, ' ').toLowerCase();
    if (comparable.startsWith('fsp arial black') || comparable.startsWith('arial black')) return "'FSP Arial Black', 'Arial Black', Arial, sans-serif";
    if (comparable.startsWith('fsp impact') || comparable.startsWith('impact')) return "'FSP Impact', Impact, 'Arial Narrow', sans-serif";
    return font;
  };
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-nav]');
  document.querySelectorAll('.shopify-policy__body h1').forEach((heading) => {
    const replacement = document.createElement('h2');
    replacement.innerHTML = heading.innerHTML;
    Array.from(heading.attributes).forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
    heading.replaceWith(replacement);
  });
  toggle?.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', String(open));
  });
  nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    nav.classList.remove('open');
    toggle?.setAttribute('aria-expanded', 'false');
  }));
  document.querySelectorAll('.standard-product-form select[name="id"]').forEach((select) => {
    select.addEventListener('change', () => {
      const label = select.selectedOptions[0]?.textContent || '';
      const match = label.match(/([\$€£][\d,.]+)/);
      const price = document.querySelector('[data-product-price]');
      if (price && match) price.textContent = match[1];
    });
  });

  function initHomeSignPreviews() {
    document.querySelectorAll('[data-home-sign]').forEach((sign) => {
      const width = Number(sign.dataset.signWidth || 14);
      const height = Number(sign.dataset.signHeight || 10);
      const inset = Number(sign.dataset.signInset || .75);
      const printableWidth = Math.max(width - inset * 2, 1);
      const printableHeight = Math.max(height - inset * 2, 1);
      const headerOutset = Math.max(inset - .5, 0);
      const safe = sign.querySelector('[data-home-safe]');
      if (!safe) return;

      sign.style.aspectRatio = `${width} / ${height}`;
      safe.style.left = `${(inset / width) * 100}%`;
      safe.style.right = `${(inset / width) * 100}%`;
      safe.style.top = `${(inset / height) * 100}%`;
      safe.style.bottom = `${(inset / height) * 100}%`;
      sign.style.setProperty('--home-header-outset-x', `${(headerOutset / printableWidth) * 100}%`);
      sign.style.setProperty('--home-header-outset-y', `${(headerOutset / printableHeight) * 100}%`);

      const fit = () => {
        if (!safe.clientWidth || !safe.clientHeight) return;
        sign.querySelectorAll('[data-home-line]').forEach((line) => {
          const text = line.querySelector('span');
          if (!text) return;
          const points = Number(line.dataset.points || 64);
          line.style.left = `${Number(line.dataset.x || 50)}%`;
          line.style.top = `${Number(line.dataset.y || 50)}%`;
          line.style.fontSize = `${((points / 72) / printableWidth) * safe.clientWidth}px`;
          text.style.position = 'static';
          text.style.left = '';
          text.style.top = '';
          text.style.transform = 'none';
          line.style.width = 'max-content';
          line.style.height = 'auto';
          const naturalWidth = Math.max(1, text.scrollWidth);
          const naturalHeight = Math.max(1, text.getBoundingClientRect().height);
          const fittedWidth = Math.min(naturalWidth, Math.max(20, safe.clientWidth - 6));
          line.style.width = `${fittedWidth}px`;
          line.style.height = `${naturalHeight}px`;
          text.style.position = 'absolute';
          text.style.left = '50%';
          text.style.top = '50%';
          text.style.transform = `translate(-50%, -50%) scaleX(${Math.min(1, fittedWidth / naturalWidth)})`;

          const halfHeight = Math.min(49, (naturalHeight / safe.clientHeight) * 50);
          const requestedY = Number(line.dataset.y || 50);
          const constrainedY = Math.min(100 - halfHeight, Math.max(halfHeight, requestedY));
          line.style.top = `${constrainedY}%`;
        });

        sign.querySelectorAll('[data-home-image]').forEach((image) => {
          image.style.left = `${Number(image.dataset.x || 50)}%`;
          image.style.top = `${Number(image.dataset.y || 50)}%`;
          const leaseName = sign.querySelector('.home-lease-name');
          const matchingWidth = image.classList.contains('home-lease-logo') && leaseName
            ? leaseName.getBoundingClientRect().width
            : 0;
          image.style.width = matchingWidth
            ? `${matchingWidth}px`
            : `${Number(image.dataset.size || 35)}%`;
          image.style.height = `${Math.max(12, safe.clientWidth * .095)}px`;
          const mark = image.querySelector('i');
          const company = image.querySelector('b');
          const descriptor = image.querySelector('small');
          if (mark) mark.style.fontSize = `${safe.clientWidth * .032}px`;
          if (company) company.style.fontSize = `${safe.clientWidth * .024}px`;
          if (descriptor) descriptor.style.fontSize = `${safe.clientWidth * .01}px`;
          const copyWidth = image.querySelector('.home-lease-logo-content>span')?.clientWidth || 0;
          [company, descriptor].filter(Boolean).forEach((copy) => {
            copy.style.transform = 'none';
            const naturalWidth = Math.max(1, copy.scrollWidth);
            copy.style.transform = `scaleX(${copyWidth / naturalWidth})`;
          });
        });

        const fixed = sign.querySelector('[data-home-pipeline-fixed]');
        if (fixed) fixed.style.fontSize = `${sign.clientWidth * .047}px`;

        const warning = sign.querySelector('[data-home-warning]');
        const warningText = warning?.querySelector('span');
        if (warning && warningText) {
          const warningInset = (0.5 / width) * sign.clientWidth;
          warning.style.padding = `0 ${warningInset}px`;
          warningText.style.fontSize = `${sign.clientWidth * .18}px`;
          warningText.style.transform = 'none';
          const style = getComputedStyle(warning);
          const availableWidth = Math.max(1, warning.clientWidth - parseFloat(style.paddingLeft || 0) - parseFloat(style.paddingRight || 0));
          const availableHeight = Math.max(1, warning.clientHeight);
          const rect = warningText.getBoundingClientRect();
          const scaleX = Math.min(1.45, Math.max(.65, (availableWidth / Math.max(1, rect.width)) * .99));
          const scaleY = Math.min(1.45, Math.max(.65, (availableHeight / Math.max(1, rect.height)) * .96));
          warningText.style.transform = `scale(${scaleX},${scaleY})`;
        }
      };

      requestAnimationFrame(fit);
      if (document.fonts?.ready) document.fonts.ready.then(fit);
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(sign);
    });
  }

  function initCartDesignPreviews() {
    const applyPreviewTextShape = (layer, shape) => {
      const text = layer.querySelector('span') || layer;
      const value = text.dataset.previewPlainText || text.textContent || '';
      text.dataset.previewPlainText = value;
      text.className = '';
      text.replaceChildren();
      if (!shape || shape === 'straight' || value.length < 2) {
        text.textContent = value;
        return;
      }
      text.classList.add('text-shaped', `text-shaped--${shape}`);
      const characters = Array.from(value);
      characters.forEach((character) => {
        const characterElement = document.createElement('span');
        characterElement.className = 'shaped-char';
        characterElement.textContent = character === ' ' ? '\u00a0' : character;
        text.appendChild(characterElement);
      });
      const characterElements = Array.from(text.children);
      const measuredWidths = characterElements.map((span) => Math.max(1, span.getBoundingClientRect().width));
      const measuredTotal = measuredWidths.reduce((sum, width) => sum + width, 0);
      const useMeasuredWidths = measuredTotal > characterElements.length;
      let cursor = 0;
      const centers = measuredWidths.map((measuredWidth) => {
        const width = useMeasuredWidths ? measuredWidth : 1;
        const center = cursor + width / 2;
        cursor += width;
        return center;
      });
      const firstCenter = centers[0] || 0;
      const lastCenter = centers[centers.length - 1] || firstCenter;
      characterElements.forEach((characterElement, index) => {
        const normalized = lastCenter > firstCenter
          ? (((centers[index] - firstCenter) / (lastCenter - firstCenter)) * 2) - 1
          : 0;
        let y = 0;
        let rotate = 0;
        if (shape === 'arch-up') { y = -0.3 * (1 - normalized * normalized); }
        else if (shape === 'arch-down') { y = 0.3 * (1 - normalized * normalized); }
        else if (shape === 'wave') {
          const progress = (normalized + 1) / 2;
          y = Math.sin(progress * Math.PI * 2) * 0.18;
          rotate = Math.cos(progress * Math.PI * 2) * 4;
        }
        characterElement.style.setProperty('--shape-y', `${y.toFixed(3)}em`);
        characterElement.style.setProperty('--shape-rotate', `${rotate.toFixed(2)}deg`);
      });
    };

    document.querySelectorAll('[data-cart-design-preview]').forEach((preview) => {
      const numbers = (preview.dataset.previewSize || '').match(/[\d.]+/g)?.slice(0, 2).map(Number) || [14, 10];
      const portrait = preview.classList.contains('is-portrait');
      const custom = preview.classList.contains('cart-preview--custom');
      const banner = preview.classList.contains('cart-preview--banner');
      const hardhat = preview.classList.contains('cart-preview--hardhat');
      const pipeline = preview.classList.contains('cart-preview--pipeline');
      const orientable = custom || banner || pipeline || hardhat;
      const width = orientable ? (portrait ? Math.min(...numbers) : Math.max(...numbers)) : numbers[0];
      const height = orientable ? (portrait ? Math.max(...numbers) : Math.min(...numbers)) : numbers[1];
      const inset = preview.classList.contains('cart-preview--lease') ? 1 : banner ? 1.5 : hardhat ? 0.125 : 0.75;
      const printableWidth = Math.max(width - inset * 2, 1);
      const printableHeight = Math.max(height - inset * 2, 1);
      const headerOutset = Math.max(inset - 0.5, 0);

      preview.style.aspectRatio = `${width} / ${height}`;
      preview.style.setProperty('--sign-width', width);
      preview.style.setProperty('--safe-x', `${(inset / width) * 100}%`);
      preview.style.setProperty('--safe-y', `${(inset / height) * 100}%`);
      preview.style.setProperty('--header-outset-x', `${(headerOutset / printableWidth) * 100}%`);
      preview.style.setProperty('--header-outset-y', `${(headerOutset / printableHeight) * 100}%`);

      let saved = [];
      try { saved = JSON.parse(preview.dataset.designLayout || '[]'); } catch (_) { saved = []; }
      const byKey = new Map(saved.map((item) => [String(item[0]), item]));
      const layoutOrderByKey = new Map(saved.map((item, index) => [String(item[0]), index]));

      let snapshot = [];
      try { snapshot = JSON.parse(preview.dataset.designSnapshot || '[]'); } catch (_) { snapshot = []; }
      const snapshotByKey = new Map(snapshot.map((item) => [String(item.key), item]));
      const snapshotOrderByKey = new Map(snapshot.map((item, index) => {
        const savedOrder = Number(item?.order);
        return [String(item?.key), Number.isFinite(savedOrder) ? savedOrder : index];
      }));
      const layerRoot = preview.querySelector('[data-preview-layer-root]');
      if (layerRoot && snapshot.length) {
        layerRoot.querySelectorAll('[data-layout-key]').forEach((layer) => layer.remove());
        snapshot.forEach((item, index) => {
          if (!item?.key) return;
          const savedOrder = Number(item.order);
          const stackOrder = Number.isFinite(savedOrder) ? savedOrder : index;
          if (pipeline && String(item.key) === 'warning') {
            return;
          }
          if (item.kind === 'image') {
            const artworkUrl = preview.dataset.artworkUrl || '';
            if (!artworkUrl) return;
            const layer = document.createElement('div');
            layer.className = 'cart-preview-image-layer';
            layer.dataset.layoutKey = item.key;
            layer.dataset.layerKind = 'image';
            layer.dataset.stackOrder = String(stackOrder);
            const image = document.createElement('img');
            image.src = artworkUrl;
            image.alt = 'Uploaded customer artwork';
            layer.appendChild(image);
            layerRoot.appendChild(layer);
            return;
          }
          if (item.kind !== 'text' || !String(item.text || '').trim()) return;
          const layer = document.createElement('div');
          layer.className = 'cart-preview-layer';
          layer.dataset.layoutKey = item.key;
          layer.dataset.stackOrder = String(stackOrder);
          const text = document.createElement('span');
          text.textContent = item.text;
          text.dataset.previewPlainText = item.text;
          layer.appendChild(text);
          layerRoot.appendChild(layer);
        });
      }

      preview.querySelectorAll('[data-layout-key]').forEach((layer) => {
        const item = byKey.get(layer.dataset.layoutKey) || [];
        const exact = snapshotByKey.get(layer.dataset.layoutKey) || null;
        const x = Number(exact?.x ?? item[1] ?? layer.dataset.defaultX ?? 50);
        const y = Number(exact?.y ?? item[2] ?? layer.dataset.defaultY ?? 50);
        const savedStackOrder = Number(layer.dataset.stackOrder);
        const stackOrder = Number.isFinite(savedStackOrder)
          ? savedStackOrder
          : snapshotOrderByKey.get(layer.dataset.layoutKey) ?? layoutOrderByKey.get(layer.dataset.layoutKey);
        layer.style.left = `${x}%`;
        layer.style.top = `${y}%`;
        const rotation = Number(exact?.rotation ?? item[10] ?? 0);
        layer.style.setProperty('--preview-rotation', `${rotation}deg`);
        if (Number.isFinite(Number(stackOrder))) layer.style.zIndex = String(2 + Number(stackOrder));
        if ((exact?.kind || layer.dataset.layerKind) === 'image') {
          const size = Number(exact?.size ?? layer.dataset.defaultSize ?? item[3] ?? 35);
          layer.style.width = `${size}%`;
          return;
        }
        const points = Number(exact?.fontSize ?? item[3] ?? layer.dataset.defaultSize ?? 64);
        layer.dataset.previewPoints = String(points);
        layer.dataset.previewOutlineColor = exact?.outlineColor || item[8] || '#e6e9ee';
        layer.dataset.previewOutlinePoints = String(Number(exact?.outlineThickness ?? item[9] ?? 0));
        layer.dataset.previewTextShape = exact?.textShape || item[11] || 'straight';
        const previewFont = normalizePreviewFont(exact?.font || item[5]);
        if (previewFont) layer.style.fontFamily = previewFont;
        if (exact?.color || item[6]) layer.style.color = exact?.color || item[6];
        applyPreviewTextShape(layer, layer.dataset.previewTextShape);
      });

      const fitLayers = () => {
        const safe = preview.querySelector('.cart-preview-safe');
        if (!safe) return;
        preview.querySelectorAll('.cart-preview-layer').forEach((layer) => {
          const points = Number(layer.dataset.previewPoints || layer.dataset.defaultSize || 64);
          layer.style.fontSize = `${((points / 72) / printableWidth) * safe.clientWidth}px`;
          layer.style.setProperty('--preview-scale-x', '1');
          applyPreviewTextShape(layer, layer.dataset.previewTextShape || 'straight');
          const text = layer.querySelector('span') || layer;
          const outlinePoints = Number(layer.dataset.previewOutlinePoints || 0);
          const outlineWidth = ((outlinePoints / 72) / printableWidth) * safe.clientWidth;
          text.style.webkitTextStroke = outlinePoints > 0 ? `${Math.max(.25, outlineWidth)}px ${layer.dataset.previewOutlineColor || '#e6e9ee'}` : '0 transparent';
          text.style.paintOrder = 'stroke fill';
          const naturalWidth = Math.max(text.scrollWidth, text.getBoundingClientRect().width, 1);
          const availableWidth = Math.max(safe.clientWidth - 6, 1);
          layer.style.setProperty('--preview-scale-x', String(Math.min(1, availableWidth / naturalWidth)));
        });
        const warning = preview.querySelector('.cart-preview-pipeline-warning');
        const warningText = warning?.querySelector('span');
        if (warning && warningText) {
          warningText.style.transform = 'none';
          const style = getComputedStyle(warning);
          const availableWidth = Math.max(1, warning.clientWidth - parseFloat(style.paddingLeft || 0) - parseFloat(style.paddingRight || 0));
          const availableHeight = Math.max(1, warning.clientHeight);
          const rect = warningText.getBoundingClientRect();
          const scaleX = Math.min(1.45, Math.max(.65, (availableWidth / Math.max(1, rect.width)) * .99));
          const scaleY = Math.min(1.45, Math.max(.65, (availableHeight / Math.max(1, rect.height)) * .96));
          warningText.style.transform = `scale(${scaleX},${scaleY})`;
        }
      };

      requestAnimationFrame(fitLayers);
      if (document.fonts?.ready) document.fonts.ready.then(fitLayers);
      if ('ResizeObserver' in window) new ResizeObserver(fitLayers).observe(preview);
    });
  }

  initHomeSignPreviews();
  initCartDesignPreviews();
})();
